import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { DialogService } from "../dialog";
import { DialogComponent } from "../dialog/dialog.component";
import { InPurchasesService } from '../../services/inventory/in-purchases.service';
import { DataService } from '../../services/data.service';
import { InTransactionsService } from '../../services/inventory/in-transactions.service'
import { DatePipe } from '@angular/common';
export interface ConfirmModelExpiryStock {
  title: string;
  message: string;
  data: any;
}
@Component({
  selector: 'expirydetails-stock',
  templateUrl: './expirydetails-stock.component.html',
  styleUrls: ['./expirydetails-stock.component.css']
})
export class ExpiryDetailsStockComponent extends DialogComponent<ConfirmModelExpiryStock, boolean> implements ConfirmModelExpiryStock, OnInit {
  title: string;
  message: string;
  loading: boolean = false;
  result: any = { item: [], result: false };
  rtnData: any;
  data: any;
  fullData: any[];
  private el: ElementRef;
  @Input() onReturn: string;
  constructor(dialogService: DialogService, private ips: InPurchasesService, private ds: DataService, public datepipe: DatePipe) {
    super(dialogService);
    this.fullData = this.data;
  }

  ngOnInit() {
    this.fullData = this.data;
    for (let i of this.fullData){
      if(i.BatchNo==""){
        this.DateChange(i,0);
      }
    }
  }
  ok() {
      this.result.result = true;
      this.result.item=this.fullData
      this.close();
  }
  DateChange(i,ix){
    var newdate = this.datepipe.transform(new Date(i.ExpiryDate), 'yyyy-MM-dd');
    i.BatchNo = newdate.toString().replace(/-/g, "");
  }  
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/expirydetails-stock/expirydetails-stock.component.ts